'use client';

import { LogoCarousel } from '@msq/components/pages/HomePageV2/components/LogoCarousel/LogoCarousel';
import { LogoSlide } from '@msq/components/pages/HomePageV2/components/LogoCarousel/LogoSlide/LogoSlide';
import { Typography } from '@ui/uikit/components/common/Typography';

import styles from './BackedAndSupportSection.module.scss';
import { backedLogoConfig } from './backedLogoConfig';
import { supportingLogoConfig } from './supportingLogoConfig';

export const BackedAndSupportSection = () => {
  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <Typography variant="h1" component="span" textAlign="center">
          Backed by Global Leaders
        </Typography>
        <LogoCarousel
          items={backedLogoConfig}
          renderItem={(item) => <LogoSlide key={item.id} height={64} {...item} />}
        />
      </section>
      <section className={styles.section}>
        <Typography variant="h1" component="span" textAlign="center">
          Supporting 160+ Ecosystems
        </Typography>
        <LogoCarousel
          gap={32}
          scrollDirection="right"
          items={supportingLogoConfig}
          renderItem={(item) => <LogoSlide key={item.id} width={48} height={48} {...item} />}
        />
      </section>
    </div>
  );
};
